<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<ngx-popover
	#popover
	[placement]="placement"
	(clickedOutside)="onClickedOutside($event, popover)"
	(clickedInside)="onClickedInside($event, popover)"
	(valueChange)="onVisibilityChange($event)"
>
	<ng-content select="[popover-trigger]" />

	<ng-template ngx-popover-template>
		<div class="popover-content">
			<ng-content select="[popover-template]" />
		</div>
	</ng-template>
</ngx-popover>
